import * as React from "react";

export const InputField: React.FC<{
  placeholder?: string;
  onChange: (e: any) => void;
  value: string | number;
  type?: string;
  min?: string | number;
  max?: string | number;
}> = ({ ...props }) => (
  <input
    className="form-input rounded w-full border-grey-12 border rounded p-4 placeholder-grey-13"
    {...props}
  />
);
